"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const is_defined_1 = require("../is-defined");
const modal_context_1 = require("./modal-context");
const buildModal = (element) => {
    const uuid = (0, uuid_1.v4)();
    return (ctx) => ({
        uuid,
        element,
        onClose: () => {
            ctx.popModal();
        },
    });
};
const elementFactory = (f) => (modalComponent, props) => {
    const element = react_1.default.createElement(modalComponent, props);
    f(element);
};
const openModal = (ctx) => elementFactory((element) => {
    const modal = buildModal(element)(ctx);
    ctx.createModal(modal);
    return () => ctx.closeModal(modal.uuid);
});
const addModal = (ctx) => elementFactory((element) => {
    const modal = buildModal(element)(ctx);
    ctx.addModal(modal);
    return () => ctx.closeModal(modal.uuid);
});
const replaceModal = (ctx) => elementFactory((element) => {
    const modal = buildModal(element)(ctx);
    ctx.replaceModal(modal);
    return () => ctx.closeModal(modal.uuid);
});
const closeModal = (ctx) => () => {
    ctx.popModal();
};
const useModal = () => {
    const context = react_1.default.useContext(modal_context_1.modalContext);
    if (!(0, is_defined_1.isValue)(context)) {
        throw new Error('useModal must be used inside ModalProvider');
    }
    return {
        openModal: openModal(context),
        closeModal: closeModal(context),
        addModal: addModal(context),
        currentLayer: context.currentLayer,
        replaceModal: replaceModal(context),
    };
};
exports.useModal = useModal;
